// extracted by mini-css-extract-plugin
module.exports = {"container":"Questions_container__1Ntsv","feedback_content":"Questions_feedback_content__2uWDr"};